<template>
  <v-container>
    <v-row justify="center">
      <v-col v-if="loading" cols="12" md="8" lg="8">
        <v-skeleton-loader v-if="loading" type="card"></v-skeleton-loader>
      </v-col>
      <v-col v-if="!loading" cols="12" md="8" lg="8">
        <v-card v-if="errorMsg">
          <v-card-text>
            <span class="red--text ma-0 sa-0">{{ errorMsg }}</span>
          </v-card-text>
        </v-card>
        <v-card v-if="!errorMsg">
          <v-card-title class="text-h5">
            <div>
              <v-avatar color="orange" size="45" class="mr-3">
                <span class="white--text text-h5">
                  {{ revProfile.PublicName.charAt(0) }}
                </span>
              </v-avatar>
              {{ revProfile.PublicName }}
            </div>
            <v-spacer></v-spacer>
            <div>
              <v-chip
                :color="revProfile.Status === 'active' ? 'green' : 'orange'"
                text-color="white"
                small
              >
                {{ revProfile.Status }}
              </v-chip>
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" class="pt-2 d-flex">
                <v-chip
                  class="mr-1"
                  small
                  v-for="company in revProfile.Companies"
                  :key="company"
                >
                  {{ company }}
                </v-chip>
              </v-col>
              <v-col cols="12" class="pt-1">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12">
                    <div class="font-weight-bold ml-8 mb-2">Experience</div>
                    <v-timeline align-top dense>
                      <v-timeline-item
                        v-for="exp in expArr"
                        :key="exp.id"
                        small
                        color="primary"
                      >
                        <div class="font-weight-normal">
                          {{ exp.role }} at
                          <strong>{{ exp.company.Name }}</strong>
                        </div>
                      </v-timeline-item>
                    </v-timeline>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" class="d-flex">
                <v-spacer></v-spacer>
                Joined {{ $utils.relativeTimeFromTs(revProfile.DateCreated) }}
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      revProfile: {},
      expArr: [],
      loading: true,
      errorMsg: "",
    };
  },
  mounted() {
    this.$utils.visit(this);
    if (this.$route.query.id !== "") {
      this.getReviewerProfile(this.$route.query.id);
    }
  },
  methods: {
    async getReviewerProfile(revId) {
      this.loading = true;
      this.errorMsg = "";
      try {
        var resp = await this.$utils.callBackendGet(
          this,
          `/pub/getReviewerPublicProfile?id=${revId}`
        );
        this.revProfile = resp;
        console.log("burny!" + JSON.stringify(this.revProfile));
        // todo: fix this mess... We parse experience because we store it in db as json which is lazy and not great.
        if (this.revProfile.Experience) {
          var exp = JSON.parse(this.revProfile.Experience);
          this.expArr = [];
          var ctr = 0;
          for (var i = 0; i < exp.length; i++) {
            for (var j = 0; j < exp[i].selRoles.length; j++) {
              this.expArr.push({
                id: ctr,
                company: exp[i].selCompany,
                role: exp[i].selRoles[j],
              });
              ctr++;
            }
          }
        }
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
